import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import useCountdownTimer from 'Components/Hooks/useCountdownTimer';

import 'Components/Timers/BundleTimer.scss';

const BundleTimer = ({
  value,
  showZero,
  hideSeconds,
  hideDays,
  commaSeparated,
  type,
  mobileTimer,
  isStarDeal,
  isSRPBundle,
}) => {
  const { days, hours, minutes, seconds } = useCountdownTimer(value);

  if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0 && !showZero) {
    return false;
  }
  if (days > 19) return false;

  const renderTime = () => {
    let timeDays = days;
    let timeHours = hours;
    let timeMinutes = minutes;
    let timeSeconds = seconds;
    const now = new Date().getTime();

    if (now > value && showZero) {
      timeDays = 0;
      timeHours = 0;
      timeMinutes = 0;
      timeSeconds = 0;
    }

    if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0 && showZero) {
      timeDays = 0;
      timeHours = 0;
      timeMinutes = 0;
      timeSeconds = 0;
    }

    return (
      <div className="number-container">
        {!hideDays &&
          <div className="number">
            {timeDays}
            <div className="number-text">
              <FormattedMessage
                id="bundletimer.days"
                defaultMessage="{count, plural, one {Day} other {Days}}"
                values={{
                  count: timeDays,
                }}
              />
              {commaSeparated && <React.Fragment>,</React.Fragment>}
            </div>
          </div>
        }
        <div className="number">
          {timeHours < 10 ? `0${timeHours}` : timeHours}
          <div className="number-text">
            <FormattedMessage
              id="bundletimer.hours"
              defaultMessage="{count, plural, one {Hour} other {Hours}}"
              values={{
                count: timeHours,
              }}
            />
            {commaSeparated && <React.Fragment>,</React.Fragment>}
          </div>
        </div>
        <div className="number">
          {timeMinutes < 10 ? `0${timeMinutes}` : timeMinutes}
          <div className="number-text">
            <FormattedMessage
              id="bundletimer.minutes"
              defaultMessage="{count, plural, one {Minute} other {Minutes}}"
              values={{
                count: timeMinutes,
              }}
            />
          </div>
        </div>
        {!hideSeconds &&
          <div className="number">
            {timeSeconds < 10 ? `0${timeSeconds}` : timeSeconds}
            <div className="number-text">
              <FormattedMessage
                id="bundletimer.seconds"
                defaultMessage="{count, plural, one {Second} other {Seconds}}"
                values={{
                  count: timeSeconds,
                }}
              />
            </div>
            {commaSeparated && <React.Fragment>,</React.Fragment>}
          </div>
        }
      </div>
    );
  };

  if (mobileTimer) {
    return (
      <div className="bundle-mobile-timer-container">
        <span className={classNames('bundle-timer', { ending: days < 4 })}>
          <div className="timer-text">
            {type === 'bundle' && !isStarDeal &&
              <FormattedMessage id="bundle-timer.bundle-ends" defaultMessage="This bundle ends in" />
            }
            {type !== 'bundle' && !isStarDeal &&
              <FormattedMessage id="bundle-timer.deal-ends" defaultMessage="This deal ends in" />
            }
            {isStarDeal &&
              <FormattedMessage id="bundle-timer.star-deal-ends" defaultMessage="This star deal ends in" />
            }
          </div>
          {renderTime()}
        </span>
      </div>
    );
  }

  return (
    <span className={classNames('bundle-timer', { ending: days < 4 })}>
      <div className="timer-text">
        {type === 'bundle' && !isSRPBundle && !isStarDeal &&
          <FormattedMessage id="bundle-timer.bundle-ends" defaultMessage="This bundle ends in" />
        }
        {(type !== 'bundle' || isSRPBundle) && !isStarDeal &&
          <FormattedMessage id="bundle-timer.deal-ends" defaultMessage="This deal ends in" />
        }
        {isStarDeal &&
          <FormattedMessage id="bundle-timer.star-deal-ends" defaultMessage="This star deal ends in" />
        }
      </div>
      {renderTime()}
    </span>
  );
};

BundleTimer.propTypes = {
  showZero: PropTypes.bool,
  mobileTimer: PropTypes.bool,
  isStarDeal: PropTypes.bool,
  isSRPBundle: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.number.isRequired,
  hideSeconds: PropTypes.bool,
  hideDays: PropTypes.bool,
  commaSeparated: PropTypes.bool,
};

BundleTimer.defaultProps = {
  showZero: false,
  mobileTimer: false,
  isStarDeal: false,
  isSRPBundle: false,
  type: 'product',
  hideSeconds: false,
  commaSeparated: false,
  hideDays: false,
};

export default BundleTimer;
